import { Row, Col, Spin } from "antd";

function LoadingCard() {
  return (
    <Row
      justify="center"
      align="middle"
      style={{ minHeight: "375px", width: "100%" }}
    >
      <Col>
        <Spin size="large" tip="Checking DoorDash status..." />
      </Col>
    </Row>
  );
}

export default LoadingCard;
